import { format, parseISO } from 'date-fns'

export const dateWithTime = (date) => {
  if (date) {
    return parseISO(date) != 'Invalid Date'
      ? format(parseISO(date), 'h:mma MM/dd/yyyy')
      : format(new Date(date), 'h:mma MM/dd/yyyy')
  }
}

export const dateUSFormat = (date) => {
  if (date) {
    if (date != 'Invalid date') {
      return parseISO(date) != 'Invalid Date'
        ? format(parseISO(date), 'MM/dd/yyyy')
        : format(new Date(date), 'MM/dd/yyyy')
    } else {
      return ''
    }
  } else {
    return ''
  }
}

export const twelveHourTimeWithZone = (date) => {
  if (date) {
    return parseISO(date) != 'Invalid Date'
      ? format(parseISO(date), 'MM/dd/yyyy h:mm a z')
      : format(new Date(date), 'MM/dd/yyyy h:mm a z')
  }
}

export const dateDbFormat = (date) => {
  if (date) {
    return parseISO(date) != 'Invalid Date'
      ? format(parseISO(date), 'yyyy-MM-dd')
      : format(new Date(date), 'yyyy-MM-dd')
  }
}
